<div class="tab-pane show active fade details-view-results trial-faqs" id="trial-faqs" role="tabpanel">
  <!-- Start: Frequently Asked Questions -->
  <div>
    <div class="title-culture-select">
      <h2>Frequently Asked Questions</h2>

      <app-button variant="primary" text="Add FAQ" (clicked)="faqModal.add()" />
    </div>
  </div>

  @if (dataLoaded) {
    <div class="trial-faqs-list" cdkDropList (cdkDropListDropped)="drop($any($event))">
      @for (faq of faqs; track faq.id; let i = $index) {
        <div class="faq-item" cdkDrag [cdkDragData]="faq">
            <div class="faq-item-left">
                <span class="drag-handle" cdkDragHandle><i class="fas fa-grip-dots"></i></span>
                <div class="faq-item-info">
                      <span class="faq-item-label">
                        {{ faq.question }}
                      </span>
                </div>
            </div>

          <div class="faq-item-actions">
            <app-button text="Remove" variant="info" size="sm" (click)="onRemove(faq)" />
            <app-button text="Edit" variant="secondary" size="sm" (clicked)="faqModal.update(faq)" />
          </div>
        </div>
      }
    </div>

    @if (faqs.length === 0) {
      <div class="no-results inside">
        <div class="inner">
          <div class="image">
            <img src="assets/img/no-results-illustration.png" alt="No results found" />
          </div>
          <div class="content">
            <h2>No Results Found</h2>
            <p>There are no FAQs assigned to this trial.</p>
          </div>
        </div>
      </div>
    }
  } @else {
    <div class="trial-faqs-list">
      <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '38px', width: '100%', 'margin-bottom': '12px' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '38px', width: '100%', 'margin-bottom': '12px' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '38px', width: '100%', 'margin-bottom': '12px' }"></ngx-skeleton-loader>
    </div>
  }
  <!-- End: Frequently Asked Questions -->
</div>

<app-confirm-action-modal #confirmModal title="Remove FAQ?" message="Are you sure you want to remove this FAQ?" (confirmed)="onRemoveConfirmed($event)"></app-confirm-action-modal>

<app-faq-form #faqModal [trial]="trial" (updated)="onAddOrUpdate($event)" />
